<ng-container *transloco="let t">
    <div
        *ngIf="notes.length"
        class="structure-scope-note"
        [class.structure-scope-note--pending]="pending"
        role="note"
    >
        <mat-icon class="icon-size-5 structure-scope-note__icon">
            {{ pending ? 'hourglass_empty' : 'info' }}
        </mat-icon>
        <div class="structure-scope-note__lines">
            <p
                *ngFor="let note of notes; trackBy: trackByNote"
                class="structure-scope-note__line"
            >
                {{ t(note.key, note.params) }}
            </p>
        </div>
    </div>
</ng-container>
